// Daily activity streak — localStorage, always LOCAL time (never UTC) so late-night visits count for the right day.
const KEY = "activityDates";

export const localDateStr = (d = new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const recordDailyActivity = () => {
  try {
    const today = localDateStr();
    const dates = JSON.parse(localStorage.getItem(KEY) || "[]");
    if (!dates.includes(today)) {
      dates.push(today);
      dates.sort();
      localStorage.setItem(KEY, JSON.stringify(dates.slice(-400)));
    }
  } catch (e) { /* storage unavailable */ }
};

export const getStreakData = () => {
  let dates = [];
  try {
    dates = JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch (e) { dates = []; }
  const set = new Set(dates);

  // current streak: consecutive days ending today
  let current = 0;
  const cursor = new Date();
  while (set.has(localDateStr(cursor))) {
    current += 1;
    cursor.setDate(cursor.getDate() - 1);
  }

  // longest streak
  let longest = 0, run = 0, prev = null;
  for (const ds of [...set].sort()) {
    if (prev) {
      const p = new Date(prev + "T12:00:00");
      p.setDate(p.getDate() + 1);
      run = localDateStr(p) === ds ? run + 1 : 1;
    } else {
      run = 1;
    }
    longest = Math.max(longest, run);
    prev = ds;
  }

  // last 7 days (oldest → today)
  const week = [];
  for (let i = 6; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    week.push({
      label: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][d.getDay()],
      date: localDateStr(d),
      active: set.has(localDateStr(d)),
      isToday: i === 0,
    });
  }

  return { current, longest, week, totalDays: set.size };
};
